import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { BrandVocabularyPopup } from './BrandVocabularyPopup';

export const BRAND_VOCABULARY_POPUP = Symbol('BRAND_VOCABULARY');

export const useBrandVocabularyPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(BRAND_VOCABULARY_POPUP, BrandVocabularyPopup);
  });

  return useCallback(
    ({ brandVoiceIds, onClose, language }) => {
      popups.openPopup(BRAND_VOCABULARY_POPUP, {
        onClose: (result) => {
          if (onClose) {
            onClose(result);
          }
          popups.closePopup(BRAND_VOCABULARY_POPUP);
        },
        brandVoiceIds,
        language,
      });
    },
    [popups]
  );
};
